
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 250 250"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M166.62 62.46a52 52 0 00-92.46 32.61v13.06H63.44a15 15 0 00-15 15v28.08a15 15 0 0015 15h1.72a75.93 75.93 0 007.41 15.15c7.38 11.46 16.89 18.12 27.66 19.47a13.91 13.91 0 0013.06 9.17h20.88a13.9 13.9 0 000-27.8h-20.88a13.92 13.92 0 00-12.83 8.56c-13.31-2.34-21-16.21-24.56-24.54h3.26a5 5 0 005-5V95.07a42 42 0 0174.68-26.33 5 5 0 007.78-6.28zm-53.33 129.73h20.88a3.9 3.9 0 010 7.8h-20.88a3.9 3.9 0 010-7.8z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M203.84 123.13v28.08a15 15 0 01-15 15h-15.72a5 5 0 01-5-5V95.07a41.79 41.79 0 00-2.33-13.83 5 5 0 119.44-3.24 51.73 51.73 0 012.89 17.12v13.06h10.72a15 15 0 0115 14.95z"}})])
          )
        }
      }
    